import React , { Component } from 'react';
import {Input } from 'reactstrap';

export default class DropDown extends Component {
    render() {
      return (
        <Input type="select" name={this.props.name} id={this.props.id} readOnly={this.props.readOnly} onChange={this.props.onChange}  defaultValue={this.props.value} className={this.props.className}>
            <option value="undefined">{this.props.first_element}</option>
            {this.props.data.map(x =>
            <option key={x.user_id} value={x.user_id}>{x.first_name}    {x.last_name}</option>)}
          </Input>
      )
    }
  }
  


// WEBPACK FOOTER //
// ./src/shared/components/DropDown/org_user.js